module.exports = __webpack_public_path__ + "media/images/number_25-b4907604cc57a48e8162445ca69979bc.png";